import arrow from '../images/arrow.svg'
import { TREE_CONTEXT_KEY } from './tree-context'

export default {
  name: 'TreeNode',
  inject: {
    treeContext: {
      from: TREE_CONTEXT_KEY,
      default: null
    }
  },
  props: {
    tmNode: {
      type: Object,
      default: () => ({})
    },
    renderContent: Function
  },
  computed: {
    label() {
      const { tmNode: {rawNode}, treeContext: {labelField} } = this
      return rawNode ? rawNode[labelField] : ''
    },
    isExpanded() {
      const { treeContext: { expandedKeys }, tmNode: {key} } = this
      return expandedKeys.includes(key)
    },
    checked() {
      const { treeContext: { checkedState }, tmNode: {key} } = this
      return checkedState.checkedKeys.includes(key)
    },
    indeterminate() {
      const { treeContext: { checkedState }, tmNode: {key} } = this
      return checkedState.indeterminateKeys.includes(key)
    },
    selected() {
      const { treeContext: { selectedKeys }, tmNode: {key} } = this
      return selectedKeys.includes(key)
    },
    showSwitcher() {
      return !this.tmNode.isLeaf
    },
    cls () {
      const { checked, indeterminate, selected, tmNode, treeContext: { group } } = this
      return [
        'layout-tree-node',
        `layout-tree-node--level-${tmNode.level}`,
        group && tmNode.level === 0 && tmNode.index > 0 && tmNode.index % 6 === 0 && 'layout-tree-node--group-start',
        group && tmNode.level === 0 && (tmNode.index + 1) % 6 === 0 && 'layout-tree-node--group-end',
        {
          'layout-tree-node--checked': checked,
          'layout-tree-node--indeterminate': indeterminate,
          'layout-tree-node--selected': selected,
        }
      ]
    }
  },
  methods: {
    handleSwitcherClick(e) {
      e.stopPropagation()
      const { treeContext: { handleSwitcherClick }, tmNode } = this
      handleSwitcherClick(tmNode)
      this.handleSelect()
    },
    handleContentClick(e) {
      e.stopPropagation()
      const { treeContext: {handleSwitcherClick}, tmNode } = this
      handleSwitcherClick(tmNode)
      this.handleSelect()
    },
    handleCheck (checked) {
      const { treeContext: { handleCheck }, tmNode } = this
      handleCheck(tmNode, checked)
      this.handleSelect()
    },
    handleSelect () {
      const { treeContext: { handleSelect }, tmNode } = this
      handleSelect(tmNode)
    }
  },
  render(h) {
    const {
      tmNode,
      label,
      isExpanded,
      showSwitcher,
      checked,
      indeterminate,
      handleCheck,
      cls,
      handleContentClick,
      handleSwitcherClick,
      renderContent
    } = this

    const indentNodes = Array.from({ length: tmNode.level }, () => (
      <div class="layout-tree-node-indent" />
    ))

    const switcherNode = showSwitcher ? (
      <span
        class={['layout-tree-node-switcher', { 'layout-tree-node-switcher--expanded': isExpanded }]}
        onClick={handleSwitcherClick}
      >
        <img src={arrow} />
      </span>
    ) : null

    return (
      <div class="layout-tree-node-wrapper">
        <div class={cls}>
          {indentNodes}
          <span class="layout-tree-node-checkbox">
            <el-checkbox value={checked} indeterminate={indeterminate} onChange={handleCheck} disabled={tmNode.disabled} />
          </span>
          <span class="layout-tree-node-content" onClick={handleContentClick}>
            {renderContent ? renderContent(h, { node: tmNode, data: tmNode.rawNode }) : label}
          </span>
          {switcherNode}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layout/components/tree/tree-node.js